import React from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import logo from './assets/econirmit_logo.png'
const ReviewSlider = () => {
  const reviews = [
    {
      id: 1,
      title: "Feels pure and authentic",
      content: "The fragrance instantly lifts the energy of my home—so subtle yet powerful.",
      author: "— Ankita Sharma",
      rating: 5
    },
    {
      id: 2,
      title: "No harsh smoke at all.",
      content: "These incense sticks have become a daily part of my prayers—clean and calming.",
      author: "— Ramesh Iyer",
      rating: 5
    },
    {
      id: 3,
      title: "But very modern in feel.",
      content: "Love how Econirmit blends heritage with quality—absolutely my kind of brand.",
      author: "— Neha Trivedir",
      rating: 5
    },
        {
      id: 3,
      title: "Tried it once—hooked! Now part of my routine.",
      content: "The sambrani cups are a game changer—pure, easy to use, and deeply grounding.",
      author: "— Siddharth Menon",
      rating: 5
    },
    {
      id: 3,
      title: "Guilt-free and graceful choice.",
      content: "Finally, products that feel good to use and align with my values.",
      author: "— Priya Joshi",
      rating: 5
    },
        {
      id: 3,
      title: "GUsed during meditation daily.",
      content: "The cones burn cleanly and truly enhance my focus without overpowering scent.",
      author: "— Rajeev Tandon",
      rating: 5
    },
    // Add more reviews as needed
  ];

  const [sliderRef] = useKeenSlider({
    loop: true,
    mode: "free-snap",
    slides: {
      origin: "center",
      perView: 1.25,
      spacing: 16,
    },
    breakpoints: {
      "(min-width: 768px)": {
        slides: {
          origin: "center",
          perView: 2.5,
          spacing: 24,
        },
      },
    },
  });

  return (
    <div className="bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">Let customers speak for us</h2>
        <p className="text-gray-600 mb-12">from 3652 reviews</p>
        
        <div ref={sliderRef} className="keen-slider">
          {reviews.map((review) => (
            <div key={review.id} className="keen-slider__slide bg-gray-50 p-6 rounded-lg shadow-sm">
            
          
              <img src={logo} style={{height:"20px"}}/>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{review.title}</h3>
             
              <p className="text-gray-600 mb-4">{review.content}</p>
                 <div className="flex items-center mb-4" style={{display:"flex", justifyContent:"center"}}>
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} className="text-yellow-400" />
                ))}
              </div>
              <p className="text-gray-900 font-medium">{review.author}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewSlider;